import { render, staticRenderFns } from "./PDFBlueprintsOverview.vue?vue&type=template&id=867c9122&scoped=true"
import script from "./PDFBlueprintsOverview.vue?vue&type=script&lang=js"
export * from "./PDFBlueprintsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867c9122",
  null
  
)

export default component.exports